module.exports = __webpack_public_path__ + "static/media/bfile-life-stage-1.4ae49dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bfile-life-stage-1.png
// module id = 2667
// module chunks = 0